import React from 'react';
import './styles/phoneMenu.css';
import CTAButton from './CTAButton';
import CTAButton2 from './CTAButton2';
import { Link, useLocation } from 'react-router-dom';

function PhoneMenu({ isOpen, onClose }) {
  const location = useLocation();
  const isActivePage = (path) => location.pathname === path;

  return (
    <div className={`phone-menu ${isOpen ? 'open' : ''}`}>
      <nav className="phone-menu-content">
        <Link 
          to="/" 
          onClick={onClose}
          className={isActivePage('/') ? 'active' : ''}
        >
          Forside
        </Link>
        <Link 
          to="/kvalitetssikring" 
          onClick={onClose}
          className={isActivePage('/kvalitetssikring') ? 'active' : ''}
        >
          Kvalitetssikring
        </Link>
        <Link 
          to="/drift-og-vedligeholdelse" 
          onClick={onClose}
          className={isActivePage('/drift-og-vedligeholdelse') ? 'active' : ''}
        >
          Drift & Vedligeholdelse
        </Link>
        <Link 
          to="/referencer" 
          onClick={onClose}
          className={isActivePage('/referencer') ? 'active' : ''}
        >
          Referencer
        </Link>
        <Link 
          to="/om" 
          onClick={onClose}
          className={isActivePage('/om') ? 'active' : ''}
        >
          Om
        </Link>
        <div className="phone-menu-buttons">
          <Link to="/kursus" onClick={onClose}>
            <CTAButton text="Kurser" />
          </Link>
          <Link to="/kontakt" onClick={onClose}>
            <CTAButton2 text="Kontakt" />
          </Link>
        </div>
      </nav>
    </div>
  );
}

export default PhoneMenu;
